var map = {
	"./belgium.svg": "9935",
	"./bosnia.svg": "aa2c",
	"./cambodia.svg": "e040",
	"./canada.svg": "dfe5",
	"./china.svg": "9498",
	"./colombia.svg": "6854",
	"./croatia.svg": "cb37",
	"./cyprus.svg": "cbff",
	"./denmark.svg": "e64e",
	"./england.svg": "4df1",
	"./france.svg": "fe6b",
	"./germany.svg": "dbaf",
	"./greece.svg": "bdbb",
	"./hungary.svg": "2e56",
	"./ireland.svg": "0935",
	"./italy.svg": "5a44",
	"./laos.svg": "96d8",
	"./myanmar.svg": "63a7",
	"./netherlands.svg": "b6cc",
	"./north-korea.svg": "c6ef",
	"./poland.svg": "e3f1",
	"./portugal.svg": "3db7",
	"./scotland.svg": "1133",
	"./serbia.svg": "b0c6",
	"./slovenia.svg": "7246",
	"./spain.svg": "3543",
	"./sweden.svg": "b4f6",
	"./thailand.svg": "c8c2",
	"./ukraine.svg": "4b30",
	"./usa.svg": "5a35",
	"./vietnam.svg": "c21f",
	"./wales.svg": "c651"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc43";